const allKeys =
  'ABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890BackspaceCapLockEnterShift1Shift2- =[]\'/` \\:,.;?!"@#$%^&*()+<>';

export default {
  activeLetters({ settings }) {
    return settings.keys || allKeys;
  }
};
